import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        // 4xx son errores del usuario/permiso: reintentar no ayuda.
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return count < 1;
      },
    },
  },
});
